class PointMarkupBuilder {
	getMarkup(pointInfo) {
		if (!pointInfo["dialect_id"]) {
			return `Pro toto místo nemáme data`;
		}

		const dialectId = parseInt(pointInfo["dialect_id"]);

		const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);
		let dialect = dialects[dialectId];

		let dialectMarkup = '';

		do {
			dialectMarkup = `<strong>${dialect.level_name}:</strong> <a href="" class="link js-show-dialect" data-dialect-id="${dialect.id}">${dialect.level != 'region' ? dialect.code : ''} ${dialect.name}</a><br>` + dialectMarkup;
			dialect = dialects[dialect.parent_id] || null;
		} while (dialect != null);

		let markup = `<div class="popup__info">`;

		if (pointInfo["NAZ_OBEC"]) {
			let name = pointInfo["NAZ_OBEC"];

			if (pointInfo["NAZ_COB"]) {
				name = pointInfo["NAZ_COB"] + ", " + name;
			}

			markup += `
    <h2>${name}</h2>
    <h3>Územie</h3>
`;

			if (pointInfo["NAZ_KRAJ"]) {
				markup += `<strong>Kraj:</strong> ${pointInfo["NAZ_KRAJ"]}<br>`;
			}

			if (pointInfo["NAZ_OKRES"]) {
				markup += `<strong>Okres:</strong> ${pointInfo["NAZ_OKRES"]}`;

				if (pointInfo["ZKR_OKRES"]) {
					markup += ` (${pointInfo["ZKR_OKRES"]})`;
				}

				markup += `<br>`;
			}

			markup += `<strong>Obec:</strong> ${pointInfo["NAZ_OBEC"]}<br>`;

			if (pointInfo["NAZ_COB"]) {
				markup += `<strong>Časť obce:</strong> ${pointInfo["NAZ_COB"]}<br>`;
			}

			if (pointInfo["NAZ_KU"]) {
				markup += `<strong>Katastrálne územie:</strong> ${pointInfo["NAZ_KU"]}<br>`;
			}
		}

		const corpora = JSON.parse(document.getElementById("appContainer").dataset.corpora);
/*
		if (pointInfo["record_count"]) {
			markup += `<br>
    <h3>Počty sond a mluvčích v korpusech</h3>
    <table class="popup__table">
        <tr>
            <th></th>
            <th scope="col">Sond</th>
            <th scope="col">Mluvčích</th>
        </tr>
`;

			let rowsMarkup = '';

			for (const corpusId in corpora) {
				const corpus = corpora[corpusId];
				rowsMarkup = `
        <tr>
            <th scope="row">${corpus.name}</th>
            <td>${pointInfo["record_count"][corpusId]}</td>
            <td>${pointInfo["speaker_count"][corpusId]}</td>
        </tr>
` + rowsMarkup;
			}

			markup += rowsMarkup + `
    </table>
`;
		}
	*/
		if (pointInfo["njo_id"]) {
			markup += `<br>
    <h3>Německý jazykový ostrov</h3>
    <strong>Český název:</strong> ${pointInfo["njo_name_cs"]}<br>
    <strong>Německý název:</strong> ${pointInfo["njo_name_de"]}<br>
    <strong>Region:</strong> ${pointInfo["njo_region"]}<br>
    <strong>Charakter:</strong> ${pointInfo["njo_characteristic"]}<br>
`;
		}
/* PMa: presunute dole
		if (pointInfo["cja_id"]) {
			markup += `<br>
    <h3>Lokalita v <abbr title="Atlas slovenského jazyka">ASJ</abbr></h3>
    <strong>Číslo:</strong> ${pointInfo["cja_id"]}<br>
    <strong>Názov:</strong> ${pointInfo["cja_nazev"]}<br>
`;
		}
*/

		if (pointInfo["example"] && pointInfo["example"].length > 0) {
			markup += `<br>
            <h3>Ukážky</h3>
`;

			for (const corpusId of pointInfo["example"]) {
				const corpus = corpora[corpusId];
				const extra = {
					corpusId: corpusId,
					KOD_OBEC: pointInfo["KOD_OBEC"],
					KOD_COB: pointInfo["KOD_COB"],
				};

				markup += `
    <a href="#" style="display: block" class="link js-open-modal" data-extra='${JSON.stringify(extra)}' data-content-type="marker-card-ukazka" data-content-key="${dialectId}">
        <i class="fas fa-volume-up"></i> Ukážka z ${corpus.name}
    </a>
`;
			}
		}

		if (pointInfo["NAZ_OBEC"]) {
			markup += `<br>`;
		}

		markup += `
    <h2>Nárečie</h2>
    ${dialectMarkup}
`;

		if (pointInfo["cja_id"]) {
			markup += `<br>
	<strong>Lokalita v <abbr title="Atlas slovenského jazyka">ASJ</abbr>:</strong> ${pointInfo["cja_id"]}<br>
`;
}

		return markup + `</div>`;
	}
}

export default new PointMarkupBuilder();
